
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/opener/[openerId]",
      function () {
        return require("private-next-pages/opener/[openerId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/opener/[openerId]"])
      });
    }
  